/**
 * SOLID Review
 * S — Strong. One use case: the server pushed a balance — kept if it is this tab's account's or seated player's.
 * O — Strong. Whose balance is kept is the Domain's decision.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The decisions port and the session's step, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { IPayloadCreditsUpdated, ICommandCreditsChanged } from '../../domain/ports/schemas/PaymentMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { IConfigDepPayment } from './IConfigDepPayment';

/** A pushed balance (FE4c; delivered on `ClientServerEvents` after a game's charge, backend §28.190). */
export class CreditsUpdatedUseCase implements IUseCase<IPayloadCreditsUpdated, TPortOutcome> {
  constructor(private readonly deps: IConfigDepPayment) {}

  async execute(ctx: IContextRequest, payload: IPayloadCreditsUpdated): Promise<TPortOutcome> {
    const { decisions, step } = this.deps;
    const changed: ICommandCreditsChanged = { playerId: payload.playerId, credits: payload.newCredits };
    return step.outcome(await step.run(ctx, (input) => decisions.creditsChanged(ctx, input, changed)));
  }
}
